<template>
    <base-page>
      <titlu-pagina Titlu="Conditii de garantie" :AdaugaVisible="false"></titlu-pagina>
      <div class="editor">
        <VueEditor v-model="Continut" />
        <div class="btn-group">
          <el-button type="success" class="buton" @click="save()"
            >Salveaza</el-button
          >
        </div>
      </div>
    </base-page>
  </template>
  
  <script>
  import BasePage from "../BasePage.vue";
  import TitluPagina from "../../../widgets/TitluPagina.vue";
  import { VueEditor } from "vue2-editor";
  
  export default {
    name: "conditii_garantie",
    extends: BasePage,
    components: {
      VueEditor,
      "base-page": BasePage,
      "titlu-pagina": TitluPagina,
    },
    data() {
      return {
        Continut: "",
      };
    },
    methods: {
      async save() {
          if (this.Continut === "" || this.Continut === null) {
              this.$message.error('Nu ati completat conditiile de garantie');
          } else {
              // console.log(this.Continut)
              try {
                let response = await this.post('admin/setari/save_conditii_garantie', {continut:this.Continut})
                this.$message.success('Conditiile de garantie au fost modificate cu succes!');
              } catch (error) {
                console.error(error);
                this.$message.error('A intervenit o problema in modificarea conditiilor de garantie!');
              }
          }
      },
      async get_conditii_garantie() {
        try {
            const response = await this.post('admin/setari/get_conditii_garantie');
            this.Continut = response.conditii_garantie;
            await this.$nextTick();
        } catch (error) {
            console.error(error);
            this.$message.error('A intervenit o problema in obtinerea conditiilor de garantie!');
        }
        
      },
      async get_info() {
        this.get_conditii_garantie();
      },
  
    },
    mounted() {
      if (!this.$has_right("Management")) {
        this.$router.push("/no-rights");
        return;
      }
      this.get_info();
    },
  };
  </script>
  
  <style lang="less" scoped>
  .top50 {
    margin-top: 20px;
  }
  
  .tag-logged {
    font-size: 12px;
    opacity: 0.5;
  }
  
  .editor {
    background-color: #fff;
    padding: 10px;
    height: 100%;
  }
  
  .btn-group {
    margin: 10px;
  }
  </style>
  